import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import lottie from "lottie-web";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  const lottieRef = useRef(null);

  useEffect(() => {
    // Lottie animation
    if (lottie && lottieRef.current) {
      const animation = lottie.loadAnimation({
        container: lottieRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../../Assets/lottie/lottie.json"), // Ensure this path is correct
      });

      return () => animation.destroy(); // Clean up animation on unmount
    }
  }, []);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There !
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Ayush Godbole</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <div ref={lottieRef} style={{ width: "100%", height: "450px" }}></div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
